// extracted by mini-css-extract-plugin
module.exports = {"modal":"archive-personnel_modal__q61NH"};